<script>
import Layout from '@layouts/main.vue';

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { Layout },
};
</script>

<template>
  <Layout>
    <Transition appear>
      <div :class="$style.loadingWrapper">
        <BaseLoadingSpinner />
      </div>
    </Transition>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.loadingWrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 30vh;
  position: absolute;
  width: 100%;
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter-active) {
    transition: opacity 1s;
  }
  // stylelint-disable-next-line selector-class-pattern
  &:global(.v-enter) {
    opacity: 0;
  }
  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep .loading {
    height: 5rem;
    width: 5rem;
  }
}
</style>
